export const props = {
  tooltip: 'r._.header.balance',
}
